import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ToolAccessModalError(props) {
  const {
    error
  } = props;
  const translationKey = `toolAccess.${error.subCategory}`;
  const isKeyValid = isValidI18nKey(translationKey);
  return /*#__PURE__*/_jsxs(Alert, {
    "data-test-id": "ui-tool-access-modal-error",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "toolAccess.error.problemSending"
    }),
    type: "danger",
    marginBlockEnd: "400",
    children: [isKeyValid && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: translationKey
      }), ' ']
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "toolAccess.error.pleaseRefresh"
    })]
  });
}
export default ToolAccessModalError;